import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
} from '@tisa-group/cdk';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';
import {UmpireComponentTypeEnum, UmpirePageTypeComponentType} from '@tisa-group/models';

@Injectable()
export class ComponentTypesService implements CrudService {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePageTypeComponentType[]>> {
    return this.http
      .get(`/component_types`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}

export interface PageTypeComponent {
  kind: UmpireComponentTypeEnum | undefined;
  label: string;
}
